import React from "react";
import { SEO, JobHistoryMain, AdminLayout } from "../../../components";

const JobHistoryMainPage = () => {
  return (
    <>
      <SEO title="Job-History" />
      <AdminLayout>
        <JobHistoryMain />
      </AdminLayout>
    </>
  );
};

export default JobHistoryMainPage;
